const remainingRouter = [
  {
    path: '/',
    redirect: (to: any) => {
      // 如果有poolNo和redirectUri参数，重定向到登录页
      if (to.query.poolNo && to.query.redirectUri) {
        return {
          path: '/login',
          query: to.query
        };
      }
      return '/login';
    }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    name: 'Login',
    meta: {
      title: '登录',
      requiresAuth: false
    }
  },
  {
    path: '/home',
    component: () => import('@/views/Home/index.vue'),
    name: 'Home',
    meta: {
      title: '数字化管理体系',
      requiresAuth: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'NoAccess',
    meta: {
      title: '403'
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFound',
    meta: {
      title: '404'
    }
  },
  {
    path: '/500',
    component: () => import('@/views/Error/500.vue'),
    name: 'Error',
    meta: {
      title: '500'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/Error/404.vue'),
    name: 'NotFoundMatch',
    meta: {
      title: '404'
    }
  }
]

export default remainingRouter
